<main id="db-wrapper">
  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
     <section id="page-content">
         <div class="header">
          <app-only-admin-navigation></app-only-admin-navigation>
         </div>

          <div class="container-fluid p-4" *ngIf="loading">
            <app-header-spinner>

            </app-header-spinner>
            <app-form-spinner></app-form-spinner>
          </div>
         <div class="container-fluid p-4" *ngIf="!loading">
           <div class="row">
             <div class="col-xl-12 mb-3 col-md-12 col-12">
               <div class="bg-primary py-6  px-xl-0 rounded-4 ">
                 <div class="row align-items-center">
                   <div class="offset-xl-1 col-xl-5 col-md-6 col-12">
                     <div>
                       <h2 class="h1 text-white mb-3 px-5">Lets manage Our Pages</h2>
                       <p class="text-white fs-4 px-5">
                        Manage Pages
                       </p>

                     </div>
                   </div>
                   <div class="col-xl-6 col-md-6 col-12">
                     <div class="text-center">
                      <i class="bi bi-file-earmark text-white" style="font-size: 48px;font-weight: 700;"></i>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
            </div>

           <div class="row">
            <div class="card p-5">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Image</th>
                    <th>Title</th>

                    <th>Edit/Delete</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let post of sessionDataArray">
                    <!-- Image column -->
                    <td>
                      <a [routerLink]="['/CompanyPage', post.id]">
                        <img src="{{post.image}}" alt="blogpost" class="avatar avatar-lg rounded-4">
                      </a>
                    </td>

                    <!-- Title column -->
                    <td>
                      <h3>
                        <a [routerLink]="['/CompanyPage', post.id]" class="text-truncate">{{post.title}}</a>
                      </h3>
                    </td>



                    <!-- Edit and Delete buttons column -->
                    <td>
                      <div class="d-flex justify-content-between">
                        <a (click)="selectRecord(post)" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#editModal">Edit</a>
                        <a (click)="deRecord(post.id)" class="btn btn-danger">Delete</a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            </div>


           </div>
       </div>

     </section>
   </main>




   <!-- Edit Modal -->
<div class="modal fade  gd-example-modal-xl" id="editModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="editModalLabel">Edit Post</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- Add your edit form here -->
        <!-- Example form fields -->
        <form [formGroup]="recordForm">
          <input type="hidden" formControlName="id">
          <div class="form-group my-2">
            <div class="text-center">
              <span class="avatar avatar-xxl  " *ngIf="imageUrl!==''">
                  <img src={{imageUrl}} alt="" class="rounded-circle">
                </span>
            </div>
            </div>
          <div class="form-group my-2">
            <label for="Image">Image /Icon for Card:</label><br>
            <input type="file" (change)="upload($event)" class="form-control" required accept="image/png, image/jpeg, image/webp, image/svg+xml">
            </div>
          <div class="mb-3">
            <label for="title" class="form-label">Title</label>
            <input type="text" class="form-control" id="title" formControlName="title">
          </div>
          <div class="form-group my-2">
            <label for="mainCategory">Main Category</label>
            <select type="text" id="mainCategory" formControlName="mainCategory" class="form-control">
              <option value="Solutions">Solutions</option>
              <option value="Resources">Resources</option>
              <option value="Platform"> Platform</option>
              <option value="About"> About</option>
            </select>
            <div *ngIf="recordForm.get('mainCategory')?.hasError('required') && recordForm.get('mainCategory')?.touched" class="error-message text-danger">
              Main Category is required.
            </div>
          </div>
          <div class="form-group my-2">
            <label for="subCategory">Sub Category</label>
            <select type="text" id="subCategory" formControlName="subCategory" class="form-control">
              <option value="Business Size"> Business Size</option>
              <option value="By Industry"> By Industry</option>
              <option value="Business Type"> Business Type</option>
              <option value="Company"> Company</option>
              <option value="Resources"> Resources</option>
              <option value="Support"> Support</option>
              <option value="Platform"> Platform</option>
              <option value="About"> About</option>
            </select>
            <div *ngIf="recordForm.get('subCategory')?.hasError('required') && recordForm.get('subCategory')?.touched" class="error-message text-danger">
              Sub Category is required.
            </div>
          </div>         
           <div class="form-group my-2">
            <label for="metaDescription">Meta Description</label>
            <textarea id="metaDescription" formControlName="metaDescription" class="form-control"></textarea>
            <div *ngIf="recordForm.get('metaDescription')?.hasError('required') && recordForm.get('metaDescription')?.touched" class="error-message text-danger">
              Meta Description is required.
            </div>
          </div>
          <div class="mb-3">
            <label for="description" class="form-label">Description</label>
            <p-editor formControlName="description" [style]="{ height: '320px' }" />
            <div *ngIf="recordForm.get('description')?.hasError('required') && recordForm.get('description')?.touched" class="error-message text-danger">
              Description is required.
            </div>
          </div>
          <!-- Add more fields as needed -->
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="updateRecord()">Save changes</button>
      </div>
    </div>
  </div>
</div>



